/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
var deskToastBar = document.currentScript.previousElementSibling;

function deskToastReadSettings(bar) {
  return {
    tooltip: bar.getAttribute("data-tooltip") || "",
    prefixes: bar.getAttribute("data-prefixes") || "",
    staticValue: bar.getAttribute("data-static-value") || "",
    staticMinimum: bar.getAttribute("data-static-minimum") || "",
    metaobject: bar.getAttribute("data-metaobject") || "",
    shop: bar.getAttribute("data-shop") || "",
    token: bar.getAttribute("data-token") || "",
    code: "",
    codeRaw: "",
    value: "",
    minimum: "",
  };
}

function deskToastReadCode(state) {
  // The URL wins over the cookie: it is the code the customer just arrived with,
  // while the cookie can still hold one from an earlier visit.
  var param = location.search.match(/[?&]discount=([^&]*)/);
  if (param) state.code = decodeURIComponent(param[1].replace(/\+/g, " "));

  var cookie = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
  if (!state.code && cookie) state.code = decodeURIComponent(cookie[1]);

  try {
    if (cookie) sessionStorage.setItem("desk_toast_cookie", "1");
    if (state.code) {
      sessionStorage.setItem("desk_toast_code", state.code);
    } else if (sessionStorage.getItem("desk_toast_cookie")) {
      sessionStorage.removeItem("desk_toast_code");
    } else {
      state.code = sessionStorage.getItem("desk_toast_code") || "";
    }
  } catch (e) {}

  state.codeRaw = state.code.trim();
  state.code = state.codeRaw.toLowerCase();

  return !!param;
}

function deskToastWasRedirected() {
  try {
    var nav = performance.getEntriesByType("navigation")[0];
    return !!(nav && nav.redirectCount > 0);
  } catch (e) {
    return false;
  }
}

function deskToastIsDismissed(state, fromLink) {
  try {
    if (fromLink) sessionStorage.removeItem("desk_toast_closed_" + state.code);
    return sessionStorage.getItem("desk_toast_closed_" + state.code) === "closed";
  } catch (e) {
    return false;
  }
}

function deskToastReadCache(state) {
  var prefixes = state.prefixes.split(",");
  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i].trim().toLowerCase();
    if (prefix && state.code.indexOf(prefix) === 0) {
      state.value = state.staticValue;
      state.minimum = state.staticMinimum;
      return;
    }
  }

  try {
    state.value = sessionStorage.getItem("desk_toast_value_" + state.code) || "";
    state.minimum = sessionStorage.getItem("desk_toast_min_" + state.code) || "";
  } catch (e) {}
}

function deskToastFill(bar) {
  var state = window.deskToast;

  var text = bar.querySelector(".desk-toast__text");
  if (text) {
    var template = text.getAttribute("data-template") || "";
    text.innerHTML = template.split("[value]").join(state.value);
  }

  var tooltip = bar.querySelector(".desk-toast__tooltip");
  if (tooltip && state.tooltip) {
    tooltip.textContent = state.tooltip
      .split("[value]").join(state.value)
      .split("[minimum]").join(state.minimum)
      .split("[code]").join(state.codeRaw.toUpperCase());
  }
}

function deskToastFormatMoney(amount, currency) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: "currency",
      currency: currency || "EUR",
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    }).format(amount);
  } catch (e) {
    return amount + " " + (currency || "");
  }
}

function deskToastLookup() {
  var state = window.deskToast;
  var handle = state.code.replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

  $.ajax({
    url: "https://" + state.shop + "/api/2024-10/graphql.json",
    method: "POST",
    contentType: "application/json",
    headers: { "X-Shopify-Storefront-Access-Token": state.token },
    data: JSON.stringify({
      query:
        "query($handle:String!,$type:String!){metaobject(handle:{type:$type,handle:$handle}){fields{key value}}}",
      variables: { handle: handle, type: state.metaobject },
    }),
  }).done(function (res) {
    var fields = res && res.data && res.data.metaobject && res.data.metaobject.fields;
    if (!fields) return;

    var data = {};
    $.each(fields, function (_, field) {
      data[field.key] = field.value;
    });

    var amount = parseFloat(data.value);
    if (isNaN(amount)) return;

    state.value =
      data.type === "percentage"
        ? Math.round(amount) + "%"
        : deskToastFormatMoney(amount, data.currency);
    state.minimum = data.minimum
      ? deskToastFormatMoney(parseFloat(data.minimum), data.currency)
      : "";

    try {
      sessionStorage.setItem("desk_toast_value_" + state.code, state.value);
      sessionStorage.setItem("desk_toast_min_" + state.code, state.minimum);
    } catch (e) {}

    $(".desk-toast").each(function () {
      deskToastFill(this);
    });
    $("html").addClass("desk-toast-on");
  });
}

function deskToastBind() {
  var state = window.deskToast;

  if (state.code && !state.value && state.metaobject && state.shop && state.token) {
    deskToastLookup();
  }

  $(document).on("click", ".desk-toast__close", function () {
    $("html").removeClass("desk-toast-on");
    try {
      sessionStorage.setItem("desk_toast_closed_" + window.deskToast.code, "closed");
    } catch (e) {}
  });
}

function deskToastInit(bar) {
  if (!bar || bar.className.indexOf("desk-toast") === -1) return;

  if (!window.deskToast) {
    var state = deskToastReadSettings(bar);
    window.deskToast = state;

    var fromLink = deskToastReadCode(state) || deskToastWasRedirected();

    if (state.code && !deskToastIsDismissed(state, fromLink)) {
      deskToastReadCache(state);
    } else {
      state.code = "";
    }

    if (state.value) document.documentElement.className += " desk-toast-on";
  }

  if (window.deskToast.value) deskToastFill(bar);

  if (!window.deskToast.bound) {
    window.deskToast.bound = true;
    $(document).ready(deskToastBind);
  }
}

deskToastInit(deskToastBar);
